import { BuildingMenuType } from '@/enums';

type CustomContentItem = {
    supportedLanguages?: string[];
};

export const isCustomContentItemVisibleForLanguage = (
    item: CustomContentItem,
    language: string,
    customMenuType?: string | null
): boolean => {
    if (String(customMenuType) !== BuildingMenuType.CUSTOM_MENU_TOGGLE_TYPE) {
        return true;
    }

    const supportedLanguages = item.supportedLanguages ?? [];
    if (supportedLanguages.length === 0) {
        return false;
    }

    return supportedLanguages.includes(language);
};
